import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Header from "./Header";
import { unregister } from "./registerServiceWorker";

const renderApp = () => {
  let reviews = document.getElementById("hibu-reviews-widget");

  if (reviews) {
    ReactDOM.render(<App {...reviews.dataset} />, reviews);
  }

  let header = document.getElementById("hibu-header-widget");
  if (header) {
    ReactDOM.render(<Header {...header.dataset} />, header);
  }
};

window.renderApp = renderApp;
renderApp();
unregister();



// WEBPACK FOOTER //
// ./src/index.js